import { KeyboardArrowDown } from "@mui/icons-material";
import { Box, Menu, MenuItem, Typography } from "@mui/material";
import { Clock, File, Fuel, Info, Wrench } from "lucide-react";
import React, { useRef, useState } from "react";

export type DeviceTabType = "INFO" | "DOCS" | "SERVICE" | "FUEL" | "HOURS";

const getIcon: (type: DeviceTabType) => React.ElementType = (type) => {
  switch (type) {
    case "INFO":
      return Info;
    case "DOCS":
      return File;
    case "SERVICE":
      return Wrench;
    case "FUEL":
      return Fuel;
    case "HOURS":
      return Clock;
  }
};

const getTitle: (type: DeviceTabType) => string = (type) => {
  switch (type) {
    case "INFO":
      return "Informationen";
    case "DOCS":
      return "Dokumente";
    case "SERVICE":
      return "Service";
    case "FUEL":
      return "Tankungen";
    case "HOURS":
      return "Betriebsstunden";
  }
};

const types = [
  { key: "INFO", name: "Informationen" },
  { key: "DOCS", name: "Dokumente" },
  { key: "SERVICE", name: "Service" },
  { key: "FUEL", name: "Tankungen" },
  { key: "HOURS", name: "Betriebsstunden" },
];

export default function DeviceMenu({
  type,
  setType,
  plusButton,
  image,
}: {
  type: DeviceTabType;
  image: string | undefined | null;
  setType: (type: DeviceTabType) => void;
  plusButton?: JSX.Element;
}) {
  const Icon = getIcon(type);
  const anchorRef = useRef<HTMLDivElement | null>(null);
  const [menuOpen, setMenuOpen] = useState(false);
  return (
    <Box
      sx={{ borderBottom: "1px solid #002169", overflow: "hidden", mb: 0, mt: 1, display: "flex", alignItems: "flex-end" }}
      style={
        !!image
          ? {
              backgroundImage: "url(" + image + ")",
              backgroundSize: "cover",
              backgroundPosition: "center",
              aspectRatio: "3/2",
              maxHeight: "40vh",
              border: "1px solid #002169",
              paddingLeft: "5px",
            }
          : {}
      }
    >
      <Box
        ref={anchorRef}
        onClick={() => setMenuOpen(true)}
        sx={{
          py: 0.5,
          px: 1,
          background: "white",
          borderColor: "#ccc",
          borderTopLeftRadius: "10px",
          cursor: "pointer",
          "&:hover": {
            position: "relative",
            top: "1px",
            left: "1px",
            backgroundColor: "#fafafa",
            boxShadow: "1px 1px 3px rgba(0,0,0,0.2)",
          },
          borderTopRightRadius: "10px",
          borderStyle: "solid",
          borderLeftWidth: 1,
          boxShadow: "1px 1px 3px rgba(0,0,0,0.5)",
          borderRightWidth: 1,
          borderBottomWidth: 0,
          borderTopWidth: 1,
          display: "flex",
          alignItems: "center",
        }}
      >
        <Icon />
        <Typography variant="h5" sx={{ ml: 1, mr: 0.5 }}>
          {getTitle(type)}
        </Typography>
        <KeyboardArrowDown />
        <Menu
          anchorEl={anchorRef.current}
          open={menuOpen}
          onClose={() => setMenuOpen(false)}
          anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
          transformOrigin={{ vertical: "top", horizontal: "left" }}
        >
          {types.map((s: any) => (
            <MenuItem
              key={s.key}
              selected={s.key === type}
              onClick={() => {
                setType(s.key);
                setMenuOpen(false);
              }}
            >
              {s.name}
            </MenuItem>
          ))}
        </Menu>
      </Box>
      <Box sx={{ flex: 1 }} />
      {!!plusButton && <Box sx={{ pb: 1, pr: 1 }}>{plusButton}</Box>}
    </Box>
  );
}
